<template>
  <section class="reply-refer-form">
    <el-form
      ref="form"
      :model="item"
      :disabled="showBuyable"
      :rules="formRules">
      <div v-show="item.quote_status == 0 && editType == 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <div class="form-item form-half">
            <span>Insurer</span>
            <el-form-item
              ref="company_id"
              prop="company_id">
              <v-select
                v-model="item.company_id"
                :list="localAllOptions.insurer"
                :disabled="editType == 3 && index == 0"
                @change="()=>(formDataLock+=1)" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Class of Insurance</span>
            <el-form-item>
              <v-select
                v-model="item.plan_id"
                :list="currentPlanOptions"
                :disabled="showBuyable || (editType == 3 && index == 0)"
                @change="()=>(formDataLock+=1)" />
            </el-form-item>
          </div>
          <div
            v-if="item.quote_status==0"
            class="form-item form-half">
            <span>Reject Renewal Notice</span>
            <el-form-item
              ref="renew_file_path_id"
              prop="rules.renew_file_path_id">
              <v-upload
                card
                widthFull
                :fileData="reject_fileData[index]"
                :otherData="otherData"
                @delete="handleDel"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
        </div>
      </div>
      <div v-show="(item.quote_status != 0 && editType == 3) || editType != 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :disabled="editType == 2"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Total Payable</span>
            <span>{{ item.payable }}</span>
          </div>
        </div>
        <div class="box">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Insurer</span>
              <el-form-item
                ref="company_id"
                prop="company_id">
                <v-select
                  v-model="item.company_id"
                  :list="localAllOptions.insurer"
                  :disabled="editType == 3 && index == 0"
                  @change="changeCompany" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Type of Insurance</span>
              <v-select
                v-model="item.class_id"
                :disabled="true"
                :list="classOptions" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Class of Insurance</span>
              <el-form-item
                ref="plan_id"
                prop="plan_id">
                <v-select
                  v-model="item.plan_id"
                  :list="currentPlanOptions"
                  :disabled="editType == 3 && index == 0"
                  @change="changePlan" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder</span>
              <v-input
                v-model="item.isrd_nm"
                :disabled="true" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Quotation Number</span>
              <v-input
                v-model="item.quote_no"
                :disabled="true" />
            </div>
            <div class="form-item form-half">
              <span>Type of quotation</span>
              <v-select
                v-model="item.type"
                :disabled="true"
                :list="globalOptions.quote_type" />
            </div>
          </div>
        </div>
        <div class="box">
          <h3>Age Limits</h3>
          <div class="flex-sb">

            <div class="form-item form-half">
              <span>Age Limits</span>
              <el-form-item
                ref="age_limits"
              >
                <v-input v-model="item.age_limits" />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box">
          <h3>Coverage</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Employer’s Liability</span>
              <v-input
                v-model="item.employer_liability"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Clinical Expenses</span>
              <v-input
                v-model="item.clinical_expenses"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Surgical and Hospitalisation Expenses</span>
              <v-input
                v-model="item.surgical_hospital_expenses"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Dental Expenses</span>
              <v-input
                v-model="item.dental_expenses"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Personal Accident Benefts</span>
              <v-input
                v-model="item.personal_accident"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Loss of Services Cash Allowances</span>
              <v-input
                v-model="item.loss_of_services"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Repatriation Expenses</span>
              <v-input
                v-model="item.repatriation_expenses"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Replacement Helper Expenses</span>
              <v-input
                v-model="item.replacement_helper_expenses"
                :keyFloatNumber="true"
                :disabled="showBuyable"
                maxlength="9"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Fidelity Guarantee</span>
              <v-input
                v-model="item.fidelity_guarantee"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Domestic Helper’s Liability</span>
              <v-input
                v-model="item.domestic_helper_liability"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Personal Effects</span>
              <v-input
                v-model="item.personal_effects"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div
            v-if="plan_cvr_remark"
            class="form-item">
            <span>Plan Coverage Remark</span>
            <span>{{plan_cvr_remark}}</span>
          </div>
          <div class="flex-sb">
            <div class="form-half">
              <div class="form-item">
                <span>Coverage Remark</span>
                <v-input
                  v-model="item.cvr_remark"
                  type="textarea"
                  :rows="3"
                />
              </div>
            </div>
          </div>
          <!-- <div class="flex-sb">
        <div class="form-item form-half">
          <span>Employees’ Compensation</span>
          <v-input v-model="item.employer_liability" />
        </div>
        <div class="form-item form-half">
          <span>Accidental death or total permanent disablement</span>
          <v-input v-model="item.personal_accident" />
        </div>
      </div>
      <div class="flex-sb">
        <div class="form-item form-half">
          <span>Clinical Coverage</span>
          <v-input v-model="item.clinical_expenses" />
        </div>
        <div class="form-item form-half">
          <span>Loss of Services Cash Allowances</span>
          <v-input v-model="item.loss_of_services" />
        </div>
      </div>
      <div class="flex-sb">
        <div class="form-item form-half">
          <span>Hospital & Surgical Coverage</span>
          <v-input v-model="item.surgical_hospital_expenses" />
        </div>
        <div class="form-item form-half">
          <span>Repatriation expenses</span>
          <v-input v-model="item.repatriation_expenses" />
        </div>
      </div>
      <div class="flex-sb">
        <div class="form-item form-half">
          <span>Dental Expenses</span>
          <v-input v-model="item.dental_expenses" />
        </div>
        <div class="form-item form-half">
          <span>Replacement Helper Expenses</span>
          <v-input v-model="item.replacement_helper_expenses" />
        </div>
      </div> -->
        </div>
        <benefit-form
          ref="benefit-form"
          :form="item"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :classId="item.class_id"
          :disabled="showBuyable"
          @getSubmitPremium="getSubmitPremium"
          @getFormData="submitPremium" />
        <!--      <div class="box">-->
        <!--        <span class="title">More Benefits</span>-->
        <!--        <div class="form-item">-->
        <!--          <v-checkbox-group-->
        <!--            v-model="item.benefits"-->
        <!--            :block="true"-->
        <!--            :disabled="showBuyable"-->
        <!--            :list="localAllOptions.benefits">-->
        <!--            <template v-slot:input="input">-->
        <!--              <v-input-->
        <!--                v-model="item.benefit_coverage[input.id]"-->
        <!--                :disabled="showBuyable" />-->
        <!--            </template>-->
        <!--          </v-checkbox-group>-->
        <!--        </div>-->
        <!--        -->
        <!--      </div>-->

        <div class="box">
          <h3>Excess</h3>
          <!-- <div class="form-half">
          <div class="form-item">
            <span>Surgical</span>
            <v-input v-model="item.surgical_ex" />
          </div>
          <div class="form-item">
            <span>Personal Effects</span>
            <v-input v-model="item.person_eff_ex" />
          </div>
          <div class="form-item">
            <span>Fidelity Coverage</span>
            <v-input v-model="item.fidelity_cov_ex" />
          </div>
          <div class="form-item">
            <span>Personal Liability</span>
            <v-input v-model="item.person_lia_ex" />
          </div>
        </div> -->
          <housemaid-excess-form
            ref="housemaid-excess-form"
            :form="item"
            :disabled="showBuyable"
            :formDataLock="excessFormDataLock"
            @getFormData="getSubFormData" />
        </div>
        <div class="box">
          <!--        <h3>Underwriting Question</h3>-->
          <!--        <div class="flex-sb-wrap">-->
          <!--          <div-->
          <!--            v-for="(inItem, inIndex) in item.underwriting"-->
          <!--            :key="inIndex"-->
          <!--            class="form-item form-half">-->
          <!--            <span>{{ inItem.name }}</span>-->
          <!--            <v-radio-group-->
          <!--              v-model="inItem.answer"-->
          <!--              :border="true"-->
          <!--              :disabled="showBuyable"-->
          <!--              :list="yesNoOptions" />-->
          <!--          </div>-->
          <!--        </div>-->
          <refer-underwriting
            ref="refer-underwriting"
            :form="item"
            :classId="item.class_id"
            :disabled="showBuyable"
            :editType="editType"
            :renewOrderId="renewOrderId"
            :formDataLock="excessFormDataLock"
            @sendPlanCvrRemark="getPlanCvrRemark"
            @getSubmitPremium="getSubmitPremium"
            @getFormData="submitPremium" />
        </div>
        <div class="box">
          <h3>Remarks</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Policy Remark</span>
              <v-input
                v-model="item.cs_manual_remark"
                type="textarea"
                :disabled="showBuyable"
                :rows="6" />
            </div>
          </div>
        </div>
        <!--      <div class="box">-->
        <!--        <h3>Premium</h3>-->
        <!--        <div class="form-half">-->
        <!--          <div class="table">-->
        <!--            <div class="tr th">-->
        <!--              <span>Item</span>-->
        <!--              <span>Amount</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Basic Premium-->
        <!--                <el-form-item-->
        <!--                  ref="basic_prm"-->
        <!--                  prop="basic_prm">-->
        <!--                  <v-input-->
        <!--                    v-model="item.basic_prm"-->
        <!--                    append="HKD" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.basic_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                MGM Discount-->
        <!--                <el-form-item-->
        <!--                  ref="code_disc_pct"-->
        <!--                  prop="code_disc_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.code_disc_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.code_disc_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Levy-->
        <!--                <el-form-item-->
        <!--                  ref="ia_levy_pct"-->
        <!--                  prop="ia_levy_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.ia_levy_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.ia_levy_vl | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Manual Discount-->
        <!--                <el-form-item-->
        <!--                  ref="spec_disc_prm"-->
        <!--                  prop="spec_disc_prm">-->
        <!--                  <v-input-->
        <!--                    v-model="item.spec_disc_prm"-->
        <!--                    append="HKD" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.spec_disc_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Admin Charge-->
        <!--                <el-form-item-->
        <!--                  ref="handling_fee"-->
        <!--                  prop="handling_fee">-->
        <!--                  <v-input-->
        <!--                    v-model="item.handling_fee"-->
        <!--                    prepend="$"-->
        <!--                    @blur="handlerReferralMain" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.handling_fee | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            &lt;!&ndash; <div class="tr">-->
        <!--            <span>-->
        <!--              Additional-->
        <!--              <v-input-->
        <!--                v-model="item.additional_charge"-->
        <!--                preppend="$" -->
        <!--                @blur="handlerReferralMain" />-->
        <!--            </span>-->
        <!--            <span>{{ item.additional_charge }}</span>-->
        <!--          </div> &ndash;&gt;-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Total Payable-->
        <!--              </span>-->
        <!--              <span>{{ item.payable | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <premium-form
          ref="premium"
          :classId="item.class_id"
          :customerId="customerId"
          :disabled="showBuyable"
          :form="item"
          :benefitList="benefitList"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :formDataLock="excessFormDataLock"
          @submitPremium="submitPremium"
          @getSubmitPremium="getSubmitPremium"></premium-form>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import HousemaidExcessForm from '@/views/tickets/components/modules/housemaid/housemaid-excess-form'
import PremiumForm from '@/views/components/premium-form'
import benefitForm from '@/views/tickets/components/modules/component/more-benefit'
import referUnderwriting from '@/views/tickets/components/form/refer-underwriting'

export default {
  name: 'HousemaidReplyReferForm',
  components: {
    PremiumForm,
    HousemaidExcessForm,
    benefitForm,
    referUnderwriting
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: [String, Number],
    customerId: {
      type: [Number,String],
      default: '' // 1 - reply, 2 - upgrade
    },
    showBuyable:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    },
    reject_fileData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      excessFormDataLock: 0,
      parentOtherData: null,
      quoteStatusOptions: [
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ],
      subForm: {
        'premium':false,
        'benefit-form':false,
      },
      plan_cvr_remark: '',
      benefitList: [],
      otherData:{
        target: 'renew_file_path_id',
        index: this.index,
        name: 'housemaid-reply-refer-form'
      }
    }
  },
  computed: {
    formRules() {
      const {quote_status} = this.item
      var rule = JSON.stringify(this.rules)
      const data =[
        'basic_prm',
        'code_disc_pct',
        'ia_levy_pct',
        'spec_disc_pct',
        'handling_fee',
        'age_limits'
      ]
      rule = JSON.parse(rule)
      data.forEach(item=>{
        rule[item][0].required =false
      })
      return quote_status==0? rule:this.rules
    },
    localAllOptions() {
      return this.allOptions21
    },
    currentPlanOptions() {
      if(!this.globalOptions || !this.globalOptions.plan) {
        return []
      }
      const { class_id, company_id } = this.item
      const key = `${company_id}${class_id}`
      return this.globalOptions.plan.filter(item => item.category_id == key)
    }
  },
  watch: {
    'item.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.changePlan()
        }
      }
    },
    'item.quote_status':{
      immediate: true,
      deep: true,
      handler(val){
        if(val == 1){
          this.handleDel({otherData: this.otherData})
        }
      }
    }
  },
  methods: {
    handleDel(otherData){
      this.$emit('delete', otherData)
    },
    handlerUploadSuccess(uploadRsult){
      this.$emit('uploadSuccess',uploadRsult)
    },
    async validateForm(otherData) {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {
        return
      }
      // this.$refs.premium.submitForm()
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid) {
            this.parentOtherData = otherData
            // 處理 excess 數據
            this.$refs['housemaid-excess-form'].submitForm()
            // this.$emit('validate', otherData)
            resolve(valid)
          }
          else {
            this.scrollToValidDom(rules)
            reject(valid)
          }
        })
      })
    },
    getSubFormData(data) {
      Object.assign(this.item, data)
      this.$emit('validate', this.parentOtherData)
    },
    getSubmitPremium(data, index, name){
      if(name == 'benefit'){
        this.benefitList = []
        Object.assign(this.benefitList, data.benefits)
      }
      Object.assign(this.item, data)
      this.$forceUpdate()
    },
    getPlanCvrRemark(data){
      this.plan_cvr_remark = data
    },
    submitPremium(form,data){
      this.subForm[form] = true
      Object.assign(this.item, data)
    },
    handlerReferralMain() {
      this.$emit('getPremium', this.index)
    },
    changeCompany(index) {
      this.excessFormDataLock+= 1
      this.$set(this.item, 'plan_id', '')
    },
    changePlan() {
      this.excessFormDataLock += 1
      this.$emit('changePlan', this.currentPlanOptions)
    },
    planOptions() {
      const { class_id, company_id } = this.item
      if(!class_id || !company_id) return []

      const key = `${company_id}${class_id}`
      const { plan } = this.globalOptions
      const options = plan[key]
      if(!options) return []
      return options
    },
  }
}
</script>
